<div class="modal-container">
    <div class="modal-header">
        <h3 class="modal-title">Update Entity Details
            <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
            <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
        </h3>
    </div>

    @if (loading) {
<div class="modal-body">
        <div class="row formLoader">
            <div class="col-md-5"></div>
            <div class="col-md-2">
                <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
            <div class="col-md-5"></div>
        </div>
    </div>
}

    @if (!loading) {
<div class="modal-body scrollable-body" [hidden]="minimise">
    <form [formGroup]="entityDetailsForm" class="form-horizontal" role="form">
        <div style="margin-left: 30px; margin-right: 30px">
            <div class="code-combo-box-key">
                <span>
                    <p><b>Entity: </b> {{rowData.LEID}} - {{rowData.CDR_NO}} - {{rowData.REPORTING_PERIOD}} </p>
                    <p><b>Form Filer Index: </b> {{rowData.FORM_FILER_IND}}</p>
                    <p><b>Entity Classification: </b> {{rowData.ENTITY_CLASSIFICATION}}</p>
                    <p><b>8858 Entity: </b> {{rowData.LEID_8858}} - {{rowData.CDR_NO_8858}} - {{rowData.REPORTING_PERIOD_8858}} </p>
                    <p><b>DATSM Applicable: </b> {{rowData.DATSM_APPLICABLE}}</p>
                    <p><b>FSE Flag (Y/N): </b> {{rowData.FSE_Y_N}}</p>
                </span>
            </div>
        </div>
        <div class="top_buffer"></div>
        @if (showInput) {
<div class="row">
            <div class="form-group">
                <label for="form_filer" class="col-md-3 control-label">Form Filer </label>
                <div class="col-md-2">
                    <select id="form_filer" name="form_filer" class="form-control"
                        [(ngModel)]="selectedFormFiler" [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="null">Select</option>
                        @for (formFiler of filerIndices; track $index) {
<option [ngValue]="formFiler">{{formFiler.label}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}
        <div class="top_buffer"></div>
        @if (showInputClass) {
<div class="row">
            <div class="form-group">
                <label for="entity_classification" class="col-md-3 control-label">Entity Classification</label>
                <div class="col-md-2">
                    <select id="entity_classification" name="entity_classification" class="form-control"
                        [(ngModel)]="selectedClassification" [ngModelOptions]="{standalone: true}" required>
                        <option [ngValue]="null">Select</option>
                        @for (entityClass of entityClassification; track $index) {
<option [ngValue]="entityClass">{{entityClass.label}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}
        <div class="top_buffer"></div>
        @if (showInput5471) {
<div class="row">
            <div class="form-group">
                <label for="datsm_applicable" class="col-md-3 control-label">DATSM Applicable</label>
                <div class="col-md-2">
                    <select id="datsm_applicable" name="datsm_applicable" class="form-control"
                        [(ngModel)]="selectedDatsmApplicable" [ngModelOptions]="{standalone: true}">
                        @for (datsmApplicable of datsmIndices; track $index) {
<option [value]="datsmApplicable.value">{{datsmApplicable.label}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}

        <div class="top_buffer"></div>
        @if (showInput8858) {
<div class="row">
            <div class="form-group">
                <label for="entities_8858" class="col-md-3 control-label">Parent 8858 </label>
                <div class="col-md-5">
                    <div class="input-group">
                        <input type="text"
                            name="entities_8858" id="entities_8858"
                            placeholder="begin typing to select 8858 Entity"
                            [formControl]="entity8858Control"
                            [matAutocomplete]="auto8858"
                            class="form-control input-sm">
                        <span class="input-group-addon">
                            @if (loading8858Accounts) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                            @if (!loading8858Accounts) {
<span><i class="fa fa-search"></i></span>
}
                        </span>
                    </div>
                    <mat-autocomplete #auto8858="matAutocomplete" (optionSelected)="on8858EntitySelected($event)" [displayWith]="display8858Entity">
                        @for (entity of filtered8858Entities | async; track $index) {
<mat-option [value]="entity">
                            {{entity.DISPLAY_LABEL}}
                        </mat-option>
}
                        @if (noResults8858 && !loading8858Accounts) {
<mat-option disabled>
                            <i class="glyphicon glyphicon-remove"></i> No Results Found
                        </mat-option>
}
                    </mat-autocomplete>
                </div>
            </div>
        </div>
}
        <!--added dat-05-01-2024-->
        <div class="top_buffer"></div>
        @if (showInputGiltiTaxType) {
<div class="row">
            <div class="form-group">
                <label for="gilti_tax_type" class="col-md-3 control-label">GILTI Tax Type</label>
                <div class="col-md-2">
                    <select id="gilti_tax_type" name="gilti_tax_type" class="form-control"
                        [(ngModel)]="selectedGiltiTaxType" [ngModelOptions]="{standalone: true}" required>
                        <option [ngValue]="null">Select</option>
                        @for (giltiTaxType of giltiTaxType; track $index) {
<option [ngValue]="giltiTaxType">{{giltiTaxType.label}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}
        <!--added dat-05-01-2024-->
        <div class="top_buffer"></div>
        @if (showInputGiltiCGK) {
<div class="row">
            <div class="form-group">
                <label for="gilti_cgk" class="col-md-3 control-label">GILTI Consol Group Key</label>
                <div class="col-md-2">
                    <select id="gilti_cgk" name="gilti_cgk" class="form-control"
                        [(ngModel)]="selectedGiltiCGK" [ngModelOptions]="{standalone: true}" required>
                        <option [ngValue]="null">Select</option>
                        @for (giltiConsolGroupKey of giltiConsolGroupKey; track $index) {
<option [ngValue]="giltiConsolGroupKey">{{giltiConsolGroupKey.LABEL}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}
        <div class="top_buffer"></div>
        @if (showFSEFlag) {
<div class="row">
            <div class="form-group">
                <label for="fse-flag" class="col-md-3 control-label">FSE Flag </label>
                <div class="col-md-2">
                    <select id="fse-flag" name="fse-flag" class="form-control"
                        [(ngModel)]="selectedFSEFlag" [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="null">Select</option>
                        @for (fseFlag of fseIndices; track $index) {
<option [ngValue]="fseFlag">{{fseFlag.label}}</option>
}
                    </select>
                </div>
            </div>
        </div>
}
    </form>
    </div>
}

    <div class="modal-footer" [hidden]="minimise">
        <div class="form-group" style="padding:15px; text-align:right">
            <button class="btn btn-info btn-sm" type="button" (click)="saveDetails()" [disabled]="crudLoading">
                @if (crudLoading) {
<span>
                    <i class="fa fa-spinner fa-pulse"></i>
                </span>
}
                Save Entity
            </button>
            <button class="btn btn-danger-outline btn-sm" type="button" (click)="resetDetails()">Reset</button>
            <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

